import { AudioPlayButton, AudioRendererProps } from "../../radioWidgets/floatingPlayer/audioPlayButton";
import { AodFloatingPlayer } from "../../radioWidgets/floatingPlayer/aodFloatingPlayer";

interface ArticleAudioComponentaProps {
    title: string
    author: string
    audioUrl: string
    durationSeconds: number
    isMobileWeb: boolean
}

export class ArticleAudioComponenta extends React.Component<ArticleAudioComponentaProps, {}> {

    public static siteScriptName = "ArticleAudioComponenta";

    public render() {

        const { title, author, durationSeconds, isMobileWeb } = this.props;
        const rangeColor = "#dee1e76c"
        const rangeThumbColor = "#fff"
        const rangeProgressColor = "#fff"

        const formatTime = (timeValue: number) => {
            const seconds = Math.floor(timeValue % 60);
            const minutes = Math.floor(timeValue - seconds) / 60;
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        };

        return (
            <div className="ArticleAudioComponenta">
                <div className="main-header">
                    <div className="main-logo" />
                </div>
                
                <div className="main-container">
                    <div className="details-container">
                        <div className="audio-roof-title">{title}</div>

                        {isMobileWeb ?
                            <AudioPlayButton
                                {...this.props}
                                durationSeconds={durationSeconds}
                                renderer={(props: AudioRendererProps) => (<RadioNewsflashMobileWeb {...props} />)}
                                floatingPlayerRenderer={(props) => (
                                    <AodFloatingPlayer
                                        {...props}
                                        title={title}
                                        site="radionas"
                                        isMobileWeb={true}
                                        rangeColor={rangeColor}
                                        rangeThumbColor={rangeThumbColor}
                                        rangeProgressColor={rangeProgressColor}
                                    />)}
                            />
                            :
                            <AudioPlayButton
                                {...this.props}
                                durationSeconds={durationSeconds}
                                renderer={(props: AudioRendererProps) => (<RadioNewsflash {...props} />)}
                                floatingPlayerRenderer={(props) => (
                                    <AodFloatingPlayer
                                        {...props}
                                        title={title}
                                        site="radionas"
                                        rangeColor={rangeColor}
                                        rangeThumbColor={rangeThumbColor}
                                        rangeProgressColor={rangeProgressColor}
                                    />)}
                            />
                        }

                        <div className="bottom-area">
                            <div className="audio-title">{author}</div>

                            <div className="separator" />

                            <div className="duration-text">{formatTime(durationSeconds)}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function RadioNewsflash({ onTogglePlayPause }: AudioRendererProps) {
    return (
        <div onClick={onTogglePlayPause} className="RadioNewsflash action-button"></div>
    );
}

function RadioNewsflashMobileWeb({ onTogglePlayPause, }: AudioRendererProps) {
    return (
        <div className="RadioNewsflashMobileWebWrapper action-button" onClick={analyticsPushFunc}>
            <div onClick={onTogglePlayPause} className="RadioNewsflashMobileWeb"></div>
        </div>
    );
}

export const analyticsPushFunc = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "GA_Events",
        Category: "Navigation Bar",
        Action: "Click to latest audio news edition",
        Label: "",
    });
}